import Dropzone from "react-dropzone";

interface FilmanizeDropZoneProps {
    readOnly: boolean;
    isUploading: boolean;
    upload: (formData: FormData) => void;
    setUploadError?: (error: string) => void;
    onboardingClassName?: string;
    acceptedFileTypes: string[];
}

const FilmanizeDropZone = (props: FilmanizeDropZoneProps) => {
    const {
        readOnly,
        isUploading,
        upload,
        setUploadError,
        onboardingClassName,
        acceptedFileTypes
    } = props;

    return (
        <>
            <div className="subtitle supported-formats mt-1">
                The following file formats are supported:
                <div className="tags script-formats">
                    {acceptedFileTypes.map((fileType: any, index: number) => <span key={index} className="tag">{fileType}</span>)}
                </div>
            </div>
            <Dropzone
                accept={acceptedFileTypes.join()}
                multiple={false}
                disabled={isUploading || readOnly}
                onDrop={(acceptedFiles, rejectedFiles) => {
                    if (acceptedFiles && acceptedFiles.length > 0) {
                        // setSaving(true);
                        const file = acceptedFiles[0];
                        const formData = new FormData();
                        formData.append("file", file);
                        formData.append("filename", file.name);
                        upload(formData);
                    }

                    if (rejectedFiles && rejectedFiles.length > 0) {
                        debugger;
                        const fileName = rejectedFiles[0].file.name;
                        const lastDot = fileName.lastIndexOf(".");
                        const extention = fileName.substring(lastDot);
                        setUploadError && setUploadError(
                            "File type " + extention + " is not supported"
                        );
                    }
                }}>
                {({ getRootProps, getInputProps, isDragActive }) => (
                    <section
                        className={`image-drop-area ${onboardingClassName} ${isDragActive ? "active" : ""}`}>
                        <div
                            {...getRootProps({ className: `image-drop-area-inner ${isDragActive ? "active" : ""}` })}>
                            <input {...getInputProps()} />
                            <button className={`button ${isUploading ? "is-loading" : ""}`} disabled={isUploading || readOnly}>Choose a file…</button>
                        </div>
                    </section>
                )}
            </Dropzone>
        </>
    );
}

export default FilmanizeDropZone;